import { render, staticRenderFns } from "./AppNavigationBoard.vue?vue&type=template&id=7278fce5&scoped=true"
import script from "./AppNavigationBoard.vue?vue&type=script&lang=js"
export * from "./AppNavigationBoard.vue?vue&type=script&lang=js"
import style0 from "./AppNavigationBoard.vue?vue&type=style&index=0&id=7278fce5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7278fce5",
  null
  
)

export default component.exports